import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './CursoVelas.css';
import { useCart } from '../../../shared/context/CartContext';

const KIT_PRODUCTO = { id: 'kit-velas-de-flores', nombre: 'KIT Velas para Mama', imagen_url: '/VelasFlores.jpg' };
const KIT_VARIANTE = { nombre: 'Estandar', precio: 1049, sku: 'kit-velas-flores-estandar' };

const INFO = [
  { icon: '🎬', label: 'Contenido',   value: '+20 videos y +10 manuales' },
  { icon: '📅', label: 'Duracion',    value: '1 mes de aprendizaje' },
  { icon: '🎓', label: 'Diploma',     value: 'Al aprobar todos los modulos' },
  { icon: '⏱️', label: 'Ritmo',       value: 'A tu propio ritmo' },
  { icon: '💻', label: 'Modalidad',   value: 'Online, 100% digital' },
  { icon: '♾️', label: 'Acceso',      value: 'De por vida, para siempre' },
  { icon: '💬', label: 'Asesoria',    value: 'Grupo exclusivo de ayuda' },
  { icon: '🌸', label: 'Tematica',    value: 'Velas florales para mama' },
];

const MODULOS = [
  { titulo: 'Modulo 1: La Vela', desc: 'Aprenderemos la historia, quimica basica y por que iniciar un negocio de velas florales.', lecciones: ['Leccion 1: Historia de la Vela', 'Leccion 2: Quimica basica de la Vela', 'Leccion 3: Por que iniciar un negocio de velas?'] },
  { titulo: 'Modulo 2: Composicion de las Velas', desc: 'Veremos a profundidad la composicion de las velas y los tipos de ceras ideales para velas florales.', lecciones: ['Leccion 4: Tipos de Ceras', 'Leccion 5: La Cera de Soya vs Parafina'] },
  { titulo: 'Modulo 3: Mechas y Pabilos', desc: 'Todo lo relacionado a los tipos de pabilos y mechas para velas decorativas.', lecciones: ['Leccion 6: Tipos de velas y mechas', 'Leccion 7: Como elegir nuestro pabilo ideal'] },
  { titulo: 'Modulo 4: Flores y Decoracion', desc: 'Aprenderas a trabajar con flores naturales y secas para decorar tus velas de forma profesional.', lecciones: ['Leccion 8: Tipos de flores para velas', 'Leccion 9: Tecnicas de incrustacion floral'] },
  { titulo: 'Modulo 5: Colorantes', desc: 'Las velas florales pueden ser de multiples colores pastel. Aprendereas a combinarlos.', lecciones: ['Leccion 10: Teoria del color', 'Leccion 11: Tipos de colorantes para velas florales'] },
  { titulo: 'Modulo 6: Aromas', desc: 'Aromas florales y femeninos para el Dia de las Madres. Aceites esenciales vs esencias.', lecciones: ['Leccion 12: Aceites esenciales vs Esencias aromaticas', 'Leccion 13: Familias olfativas florales'] },
  { titulo: 'Modulo 7: Primeros Pasos', desc: 'Los pasos iniciales antes de comenzar a elaborar tus primeras velas florales.', lecciones: ['Leccion 14: Primeros pasos'] },
  { titulo: 'Modulo 8: Recetas Basicas', desc: 'Comenzaremos a elaborar nuestras primeras recetas de velas florales.', lecciones: ['Leccion 15: Vela Natural Floral', 'Leccion 16: Vela Aromatica de Rosas', 'Leccion 17: Vela de Jazmin', 'Leccion 18: Vela de Lavanda'] },
  { titulo: 'Modulo 9: Recetas Avanzadas', desc: 'Recetas especiales con tematica del Dia de las Madres.', lecciones: ['Leccion 19: Vela Bouquet de Flores', 'Leccion 20: Vela Pastel Floral', 'Leccion 21: Vela con Flores Secas Prensadas', 'Leccion 22: Vela Geoda Floral', 'Leccion 23: Vela Corazon para Mama'] },
  { titulo: 'Examen Final', desc: 'Tu ultimo paso sera presentar el examen final. Al aprobarlo recibiras tu diploma.', lecciones: [] },
];

const DEADLINE = new Date('2026-06-15T23:59:59');

function useCountdown(target) {
  const calc = () => {
    const diff = Math.max(0, target - Date.now());
    return { d: Math.floor(diff / 86400000), h: Math.floor((diff % 86400000) / 3600000), m: Math.floor((diff % 3600000) / 60000), s: Math.floor((diff % 60000) / 1000) };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => { const id = setInterval(() => setTime(calc()), 1000); return () => clearInterval(id); }, []);
  return time;
}

function pad(n) { return String(n).padStart(2, '0'); }

function scrollToPrecio(e) {
  e.preventDefault();
  document.getElementById('precio-flores')?.scrollIntoView({ behavior: 'smooth' });
}

function DescuentoForm() {
  const [telefono, setTelefono] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [sending, setSending] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      await fetch('/api/leads', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ telefono, email, tipo: 'descuento_curso_velas_flores' }) });
      if (window.fbq) window.fbq('track', 'Lead', { content_name: 'Descuento Curso Velas Flores' });
      setSent(true);
    } catch {}
    setSending(false);
  };

  return (
    <div id="descuento-form" data-reveal style={{ background: '#F6EDE3', padding: '52px 32px', textAlign: 'center' }}>
      {!sent ? (
        <>
          <p style={{ fontSize: 11, fontWeight: 800, color: '#B08968', letterSpacing: 3, textTransform: 'uppercase', margin: '0 0 14px' }}>Oferta exclusiva</p>
          <h2 style={{ fontSize: 28, fontWeight: 900, color: '#4A3F35', margin: '0 0 12px', fontFamily: 'Georgia, serif', lineHeight: 1.25 }}>Obten $250 de descuento<br />en el Kit Velas para Mama</h2>
          <p style={{ color: '#7A6A5A', fontSize: 14, margin: '0 auto 32px', lineHeight: 1.7, maxWidth: 360 }}>Deja tu correo y te enviamos el cupon al instante. Sin spam, solo tu descuento.</p>
          <form onSubmit={enviar} style={{ maxWidth: 360, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', border: '1.5px solid #B08968', borderRadius: 10, overflow: 'hidden', background: '#fff' }}>
              <span style={{ padding: '0 12px', display: 'flex', alignItems: 'center', color: '#7A6A5A', fontSize: 13, flexShrink: 0 }}>🇲🇽 +52</span>
              <input type="tel" placeholder="Numero de telefono" value={telefono} onChange={e => setTelefono(e.target.value)} style={{ flex: 1, background: 'transparent', border: 'none', padding: '14px 12px 14px 0', fontSize: 14, color: '#4A3F35', outline: 'none', fontFamily: 'inherit' }} />
            </div>
            <input type="email" placeholder="Correo electronico *" value={email} onChange={e => setEmail(e.target.value)} required style={{ background: '#fff', border: '1.5px solid #B08968', borderRadius: 10, padding: '14px 16px', fontSize: 14, color: '#4A3F35', outline: 'none', fontFamily: 'inherit' }} />
            <button type="submit" disabled={sending} style={{ background: '#B08968', color: '#fff', border: 'none', borderRadius: 10, padding: '15px', fontSize: 15, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', letterSpacing: 0.5, marginTop: 4 }}>
              {sending ? 'Enviando...' : 'RECLAMAR MI DESCUENTO'}
            </button>
          </form>
        </>
      ) : (
        <>
          <div style={{ fontSize: 52, marginBottom: 16 }}>🌸</div>
          <h2 style={{ fontSize: 24, fontWeight: 900, color: '#4A3F35', margin: '0 0 10px', fontFamily: 'Georgia, serif' }}>Tu descuento esta listo!</h2>
          <p style={{ color: '#7A6A5A', fontSize: 14, margin: '0 0 32px' }}>Usalo al inscribirte al Kit Velas para Mama</p>
          <div style={{ background: '#F3EFE8', border: '2px dashed #B08968', borderRadius: 16, padding: '28px 40px', display: 'inline-block' }}>
            <p style={{ fontSize: 11, color: '#7A6A5A', margin: '0 0 10px', textTransform: 'uppercase', letterSpacing: 1.5 }}>Tu cupon de descuento</p>
            <p style={{ fontSize: 38, fontWeight: 900, color: '#4A3F35', margin: '0 0 8px', letterSpacing: 5 }}>MAMA250</p>
            <p style={{ fontSize: 12, color: '#B08968', margin: 0 }}>Valido para el Kit Velas para Mama</p>
          </div>
          <p style={{ color: '#7A6A5A', fontSize: 13, marginTop: 20 }}>Tambien te lo enviamos a tu correo</p>
        </>
      )}
    </div>
  );
}

export default function CursoVelasFlores() {
  const { d, h, m, s } = useCountdown(DEADLINE);
  const [openModulo, setOpenModulo] = useState(null);
  const [openFaq, setOpenFaq] = useState(0);
  const { addToCart, clearCart } = useCart();
  const navigate = useNavigate();

  function comprarKit() {
    clearCart();
    addToCart(KIT_PRODUCTO, KIT_VARIANTE, 1);
    navigate('/checkout');
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('cv-revealed'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const NOTA = (
    <p style={{ fontSize: 13, color: '#7A6A5A', textAlign: 'center', lineHeight: 1.7, margin: '16px 0 0' }}>
      Inscripcion inmediata, no tendras que esperar ni 5 minutos.{' '}
      <strong style={{ color: '#4A3F35' }}>NOTA:</strong> Tenemos{' '}
      <strong style={{ color: '#4A3F35' }}>7 dias de garantia</strong>, si el curso no es lo que buscas,{' '}
      <strong style={{ color: '#4A3F35' }}>te rembolsaremos el 100% de tu inscripcion</strong> sin ningun problema.
    </p>
  );

  return (
    <div className="cv-page">
      <nav className="cv-nav">
        <Link to="/" style={{ color: '#B08968', fontWeight: 700, textDecoration: 'none', fontSize: 15 }}>← Be Alquimist</Link>
        <span style={{ color: '#B08968', fontSize: 13, fontWeight: 600, letterSpacing: 1 }}>CURSOS</span>
      </nav>

      <div className="cv-wrapper">

        <div className="cv-header">
          <p style={{ color: '#F3EFE8', fontSize: 11, fontWeight: 700, letterSpacing: 4, margin: '0 0 14px', textTransform: 'uppercase', opacity: 0.85 }}>🌸 Be Alquimist</p>
          <h1 style={{ color: '#F3EFE8', fontSize: 32, fontWeight: 900, lineHeight: 1.2, margin: '0 0 14px', textTransform: 'uppercase', letterSpacing: 3, fontFamily: 'Georgia, serif' }}>
            Kit Velas<br />para Mama
          </h1>
          <p style={{ color: '#F3EFE8', fontSize: 14, fontWeight: 400, margin: 0, opacity: 0.9, lineHeight: 1.6 }}>
            Aprende a crear velas florales unicas y convierte tu pasion en negocio
          </p>
        </div>

        <div className="cv-intro">
          <div className="cv-img-wrap">
            <img src="/VelasFlores.jpg" alt="Kit Velas para Mama" />
          </div>
          <div className="cv-info">
            <h2 style={{ fontSize: 16, fontWeight: 800, color: '#4A3F35', textTransform: 'uppercase', letterSpacing: 1.5, margin: '0 0 18px' }}>Detalles del curso</h2>
            <div className="cv-info-grid">
              {INFO.map(({ icon, label, value }) => (
                <div key={label} className="cv-info-chip">
                  <span className="cv-info-chip-icon">{icon}</span>
                  <div>
                    <div className="cv-info-chip-label">{label}</div>
                    <div className="cv-info-chip-value">{value}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="cv-cta-wrap" style={{ padding: 0, marginTop: 24 }}>
              <a href="#precio-flores" onClick={scrollToPrecio} style={{ display: 'inline-block', background: '#B08968', color: '#fff', fontWeight: 700, fontSize: 14, padding: '14px 44px', borderRadius: 30, textDecoration: 'none', letterSpacing: 2, textTransform: 'uppercase' }}>
                Inscribete ahora
              </a>
            </div>
          </div>
        </div>

        <div className="cv-cta-wrap">
          <a href="#precio-flores" onClick={scrollToPrecio} style={{ display: 'inline-block', background: '#B08968', color: '#fff', fontWeight: 700, fontSize: 14, padding: '14px 44px', borderRadius: 30, textDecoration: 'none', letterSpacing: 2, textTransform: 'uppercase' }}>
            Inscribete ahora
          </a>
        </div>

        <DescuentoForm />

        <div data-reveal style={{ background: '#FAF7F2', padding: '40px 32px' }}>
          <p style={{ fontSize: 11, fontWeight: 800, color: '#B08968', letterSpacing: 3, textTransform: 'uppercase', margin: '0 0 10px', textAlign: 'center' }}>Lo que aprenderas</p>
          <h2 style={{ fontSize: 24, fontWeight: 900, color: '#4A3F35', margin: '0 0 28px', fontFamily: 'Georgia, serif', textAlign: 'center', lineHeight: 1.3 }}>Que incluye el curso?</h2>
          {[
            'Formulas naturales de velas, con opciones veganas y economicas.',
            'Procedimientos de elaboracion basicos y avanzados.',
            'Tips y soluciones para trabajar con flores secas.',
            'Tipos de recipientes ideales para velas florales.',
            'Tipos de mechas y pabilos recomendados.',
            'Aromas florales: aceites esenciales y esencias.',
            'Tipos de ceras para velas decorativas.',
            'Colorantes pasteles para combinaciones florales.',
            'Recetas basicas de velas florales para comenzar.',
            'Recetas avanzadas tematicas para el Dia de las Madres.',
          ].map(item => (
            <p key={item} style={{ fontSize: 15, color: '#4A3F35', lineHeight: 1.8, margin: '0 0 6px' }}>✅ {item}</p>
          ))}
        </div>

        <div className="cv-social" data-reveal>
          <div style={{ background: '#B08968', padding: '22px 32px', textAlign: 'center' }}>
            <h2 style={{ color: '#F3EFE8', fontSize: 22, fontWeight: 900, margin: 0, textTransform: 'uppercase', letterSpacing: 3, fontFamily: 'Georgia, serif' }}>Lo que dicen nuestras alumnas</h2>
          </div>
          <div className="cv-stats">
            {[{ n: '+340', label: 'Alumnas activas' }, { n: '4.9★', label: 'Calificacion' }, { n: '98%', label: 'Lo recomiendan' }].map(({ n, label }) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 26, fontWeight: 900, color: '#B08968' }}>{n}</div>
                <div style={{ fontSize: 12, color: '#7A6A5A', fontWeight: 600, marginTop: 2 }}>{label}</div>
              </div>
            ))}
          </div>
          <div className="cv-reviews">
            {[
              { nombre: 'Valeria M.', ciudad: 'Guadalajara', stars: 5, texto: 'Hice las velas de flores para el Dia de las Madres y se vendieron todas en un dia. El curso es clarisimo y los disenos quedan preciosos.' },
              { nombre: 'Daniela R.', ciudad: 'CDMX', stars: 5, texto: 'Lo mejor fue aprender a trabajar con flores secas. Nunca pense que quedarian tan bien. Ahora tengo pedidos para bodas y XV anos tambien.' },
              { nombre: 'Sofia L.', ciudad: 'Monterrey', stars: 5, texto: 'El kit llego completo con todo lo necesario. En menos de una semana ya tenia mis primeras velas listas para regalar y vender.' },
              { nombre: 'Mariana T.', ciudad: 'Puebla', stars: 5, texto: 'Le regale una vela floral a mi mama y lloro de la emocion. Ahora hago pedidos personalizados y me va increible.' },
            ].map(({ nombre, ciudad, stars, texto }) => (
              <div key={nombre} className="cv-review-card">
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                  <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#B08968', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 16, flexShrink: 0 }}>{nombre[0]}</div>
                  <div>
                    <div style={{ fontWeight: 700, color: '#4A3F35', fontSize: 14 }}>{nombre}</div>
                    <div style={{ fontSize: 12, color: '#9E9188' }}>{ciudad}</div>
                  </div>
                  <div style={{ marginLeft: 'auto', color: '#B08968', fontSize: 15 }}>{'★'.repeat(stars)}</div>
                </div>
                <p style={{ fontSize: 13, color: '#7A6A5A', lineHeight: 1.7, margin: 0 }}>{texto}</p>
              </div>
            ))}
          </div>
        </div>

        <div id="precio-flores" data-reveal>
          <div style={{ background: '#B08968', padding: '22px 32px', textAlign: 'center' }}>
            <h2 style={{ color: '#F3EFE8', fontSize: 24, fontWeight: 900, margin: 0, textTransform: 'uppercase', letterSpacing: 3, fontFamily: 'Georgia, serif' }}>Precio</h2>
          </div>
          <div className="cv-cards">
            <div style={{ border: '2px solid #B08968', borderRadius: 14, overflow: 'hidden' }}>
              <div style={{ background: '#B08968', padding: '12px 20px', textAlign: 'center' }}>
                <span style={{ color: '#F3EFE8', fontWeight: 800, fontSize: 14, letterSpacing: 3, textTransform: 'uppercase' }}>Popular</span>
              </div>
              <div style={{ padding: '24px 24px 20px', textAlign: 'center' }}>
                <h3 style={{ color: '#4A3F35', fontWeight: 800, fontSize: 20, margin: '0 0 10px' }}>Kit Velas para Mama</h3>
                <div style={{ marginBottom: 16 }}>
                  <span style={{ color: '#9E9188', fontSize: 16, textDecoration: 'line-through', marginRight: 10 }}>$1,300</span>
                  <span style={{ color: '#B08968', fontSize: 32, fontWeight: 900 }}>$1,049 MXN</span>
                </div>
                {['Todo el material incluido', 'Flores y aromas florales', 'Pago unico', 'Acceso de por vida', 'Actualizaciones incluidas', 'Envio incluido'].map(item => (
                  <p key={item} style={{ fontSize: 14, color: '#4A3F35', fontWeight: 600, margin: '0 0 8px', textDecoration: 'underline' }}>{item}</p>
                ))}
                <button onClick={comprarKit} style={{ display: 'inline-block', marginTop: 16, background: '#4A3F35', color: '#fff', fontWeight: 700, fontSize: 15, padding: '14px 36px', borderRadius: 30, border: 'none', cursor: 'pointer', width: '100%' }}>
                  Inscribete Aqui
                </button>
                {NOTA}
              </div>
            </div>
          </div>
        </div>

        <div className="cv-countdown" data-reveal>
          <h2 style={{ color: '#F3EFE8', fontSize: 22, fontWeight: 800, margin: '0 0 24px', lineHeight: 1.3 }}>Tiempo para que<br />termine la promocion</h2>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
            {[{ val: pad(d), label: 'dias' }, { val: pad(h), label: 'horas' }, { val: pad(m), label: 'min' }, { val: pad(s), label: 'seg' }].map(({ val, label }, i, arr) => (
              <React.Fragment key={label}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ background: '#F3EFE8', color: '#4A3F35', fontWeight: 900, fontSize: 32, borderRadius: 10, padding: '10px 14px', minWidth: 56, lineHeight: 1 }}>{val}</div>
                  <div style={{ color: '#F3EFE8', fontSize: 11, fontWeight: 600, marginTop: 6, textTransform: 'uppercase', letterSpacing: 1 }}>{label}</div>
                </div>
                {i < arr.length - 1 && <span style={{ color: '#F3EFE8', fontSize: 28, fontWeight: 900, alignSelf: 'flex-start', paddingTop: 10 }}>:</span>}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div data-reveal>
          <div style={{ background: '#C9A882', padding: '22px 32px', textAlign: 'center' }}>
            <h2 style={{ color: '#F3EFE8', fontSize: 22, fontWeight: 900, margin: 0, textTransform: 'uppercase', letterSpacing: 3, fontFamily: 'Georgia, serif' }}>Temario</h2>
          </div>
          <div style={{ padding: '28px 28px 36px' }}>
            {MODULOS.map((mod, i) => {
              const isOpen = openModulo === i;
              return (
                <div key={i} style={{ marginBottom: 12, borderRadius: 10, overflow: 'hidden', border: '1px solid #EDE0D4' }}>
                  <button onClick={() => setOpenModulo(isOpen ? null : i)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: isOpen ? '#fff' : '#F5EDE3', border: 'none', padding: '16px 20px', cursor: 'pointer', textAlign: 'left' }}>
                    <span style={{ fontWeight: 800, fontSize: 14, color: '#4A3F35', textTransform: 'uppercase', letterSpacing: 0.5 }}>{mod.titulo}</span>
                    <span style={{ width: 28, height: 28, borderRadius: '50%', background: '#4A3F35', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 18, fontWeight: 700, flexShrink: 0, marginLeft: 12, transform: isOpen ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s' }}>+</span>
                  </button>
                  {isOpen && (
                    <div style={{ background: '#fff', padding: '16px 20px 20px', borderTop: '1px solid #F0E8DE' }}>
                      <p style={{ fontSize: 13, color: '#7A6A5A', lineHeight: 1.7, margin: '0 0 12px' }}>{mod.desc}</p>
                      {mod.lecciones.length > 0 && (
                        <ul style={{ margin: 0, paddingLeft: 18 }}>
                          {mod.lecciones.map(l => <li key={l} style={{ fontSize: 13, color: '#4A3F35', marginBottom: 6, lineHeight: 1.5 }}>{l}</li>)}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div style={{ background: '#F3EFE8' }} data-reveal>
          <div className="cv-paratiif">
            <div className="cv-paratiif-img">
              <img src="/VelasFlores.jpg" alt="Kit Velas para Mama" style={{ maxWidth: '100%', height: 'auto', borderRadius: 12, display: 'block' }} />
            </div>
            <div className="cv-paratiif-text">
              <p style={{ fontStyle: 'italic', fontSize: 13, color: '#7A6A5A', margin: '0 0 10px' }}>Por que inscribirte en Be Alquimist?</p>
              <h2 style={{ fontSize: 22, fontWeight: 900, color: '#4A3F35', textTransform: 'uppercase', margin: '0 0 24px', letterSpacing: 0.5 }}>Este curso es para ti si:</h2>
              {[
                'Deseas iniciar tu propia marca de velas florales.',
                'Quieres hacer un regalo unico para el Dia de las Madres.',
                'Has estado haciendo velas y quieres aprender tecnicas florales avanzadas.',
                'Quieres aprender de un equipo de Biotecnologos especialistas en cosmetica.',
                'Quieres convertir tu pasion por las flores en un negocio rentable.',
              ].map(item => (
                <div key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 16 }}>
                  <span style={{ fontSize: 18, flexShrink: 0, marginTop: 1 }}>🌸</span>
                  <p style={{ fontSize: 14, color: '#4A3F35', lineHeight: 1.6, margin: 0 }}>{item}</p>
                </div>
              ))}
            </div>
          </div>
          <div style={{ textAlign: 'center', padding: '40px 32px 56px' }}>
            <h2 style={{ fontSize: 28, fontWeight: 700, color: '#4A3F35', margin: '0 0 24px', fontFamily: 'Georgia, serif' }}>Deseas inscribirte?</h2>
            <a href="#precio-flores" onClick={scrollToPrecio} style={{ display: 'inline-block', background: '#B08968', color: '#fff', fontWeight: 700, fontSize: 15, padding: '16px 48px', borderRadius: 30, textDecoration: 'none', letterSpacing: 0.5 }}>
              Si! Deseo inscribirme
            </a>
          </div>
        </div>

        <div data-reveal>
          <div style={{ background: '#B08968', padding: '28px 32px', textAlign: 'center' }}>
            <h2 style={{ color: '#F3EFE8', fontSize: 24, fontWeight: 900, margin: '0 0 6px', textTransform: 'uppercase', letterSpacing: 3, fontFamily: 'Georgia, serif' }}>Preguntas Frecuentes</h2>
          </div>
          <div style={{ padding: '28px 28px 16px' }}>
            {[
              { q: 'Incluye los materiales?', a: 'Si, el KIT incluye todos los materiales necesarios: cera, flores secas, aromas florales, mechas y colorantes pasteles.' },
              { q: 'Y si no tengo experiencia en velas?', a: 'No te preocupes, este curso esta disenado para principiantes. Empezamos desde lo mas basico.' },
              { q: 'Se puede realizar desde cualquier lugar?', a: 'Si! El curso es 100% online y el kit se envia a toda la republica.' },
              { q: 'Las flores que se usan son naturales?', a: 'Si! Trabajamos con flores naturales secas y prensadas para lograr disenos unicos y duraderos.' },
              { q: 'Me daran un certificado?', a: 'Al finalizar tu curso seras acreedora a un Diploma donde acreditamos tu formacion en Be Alquimist.' },
            ].map(({ q, a }, i) => {
              const isOpen = openFaq === i;
              return (
                <div key={i} style={{ marginBottom: 12, borderRadius: 10, overflow: 'hidden', border: '1px solid #EDE0D4' }}>
                  <button onClick={() => setOpenFaq(isOpen ? null : i)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: isOpen ? '#fff' : '#FAF7F2', border: 'none', padding: '16px 20px', cursor: 'pointer', textAlign: 'left' }}>
                    <span style={{ fontWeight: 700, fontSize: 14, color: '#4A3F35', lineHeight: 1.4 }}>{q}</span>
                    <span style={{ width: 28, height: 28, borderRadius: '50%', background: '#4A3F35', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 18, fontWeight: 700, flexShrink: 0, marginLeft: 12, transform: isOpen ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s' }}>+</span>
                  </button>
                  {isOpen && (
                    <div style={{ background: '#fff', padding: '14px 20px 18px', borderTop: '1px solid #F0E8DE' }}>
                      <p style={{ fontSize: 14, color: '#7A6A5A', lineHeight: 1.7, margin: 0 }}>{a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div style={{ textAlign: 'center', padding: '16px 32px 56px' }}>
            <a href="#precio-flores" onClick={scrollToPrecio} style={{ display: 'inline-block', background: '#B08968', color: '#fff', fontWeight: 700, fontSize: 14, padding: '14px 48px', borderRadius: 30, textDecoration: 'none', letterSpacing: 2, textTransform: 'uppercase' }}>
              Inscribirme Ahora
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}
